import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon
    {...props}
    width="63"
    height="74"
    viewBox="0 0 63 74"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="31.7268" cy="38.541" r="11.3768" fill="#CE8C0C" />
    <circle
      cx="31.7268"
      cy="37.2768"
      r="11.3768"
      fill="url(#paint0_linear_1959_155)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.727 45.4932C36.2649 45.4932 39.9436 41.8146 39.9436 37.2767C39.9436 32.7388 36.2649 29.0601 31.727 29.0601C27.1891 29.0601 23.5104 32.7388 23.5104 37.2767C23.5104 41.8146 27.1891 45.4932 31.727 45.4932ZM31.727 46.7573C36.963 46.7573 41.2076 42.5127 41.2076 37.2767C41.2076 32.0407 36.963 27.796 31.727 27.796C26.491 27.796 22.2463 32.0407 22.2463 37.2767C22.2463 42.5127 26.491 46.7573 31.727 46.7573Z"
      fill="#E2AB1A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39.9432 37.2767C39.9432 31.5883 35.1508 29.4175 33.9388 28.7441C32.7268 28.0707 31.7267 27.796 31.7267 27.796C36.9627 27.796 41.2073 32.0407 41.2073 37.2767C41.2073 42.5127 36.9627 46.7573 31.7267 46.7573C31.7267 46.7573 32.043 46.7522 33.9388 46.1253C35.8347 45.4984 39.9432 41.8146 39.9432 37.2767Z"
      fill="#D89C00"
    />
    <path
      d="M31.286 41.7013C30.1582 41.7013 29.0724 41.3923 28.1132 40.7194C27.4446 40.2506 26.6708 39.1921 26.6708 37.3975C26.6708 34.0682 28.3491 32.8531 31.7219 32.8531L36.5682 32.8531C36.5682 32.8531 36.7175 32.8453 36.7598 32.8957C36.8131 32.9591 36.7598 33.1089 36.7598 33.1089L36.3037 34.5264C36.3037 34.5264 36.2434 34.6582 36.1807 34.7011C36.1073 34.7514 35.9881 34.7494 35.9881 34.7494H32.1846C29.9585 34.7494 28.6349 34.9253 28.6349 37.3975C28.6349 38.2141 28.8621 38.7953 29.3299 39.1739C30.1204 39.814 31.657 39.8412 32.5959 39.7495C32.5959 39.7495 32.9811 38.4943 33.0446 38.2905C33.1189 38.0517 33.0863 37.9948 32.8545 37.9948C32.5197 37.9948 31.9177 37.9948 31.2788 37.9948C30.8311 37.9948 30.3912 37.7664 30.3912 37.218C30.3912 36.6883 30.8005 36.3809 31.3615 36.3809C32.3328 36.3809 34.3334 36.3809 34.7078 36.3809C35.1987 36.3809 35.6996 36.4522 35.4441 37.2397L34.0905 41.3992C34.0905 41.3992 32.9848 41.7013 31.286 41.7013Z"
      fill="#E2A60B"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1959_155"
        x1="31.7268"
        y1="25.9"
        x2="31.7268"
        y2="48.6536"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEDC28" />
        <stop offset="1" stopColor="#F1C34B" />
      </linearGradient>
    </defs>
  </SvgIcon>
));
